import React, { createContext, useReducer } from "react";
import AppReducer from "./AppReducer";

// Initial state
const initialState = {
  userData: null,
};

const GlobalContext = createContext(initialState);
export default GlobalContext;

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);

  const setUserData = (userData) => {
    dispatch({
      type: "SET_Data",
      payload: userData,
    });
  };

  return (
    <GlobalContext.Provider
      value={{
        userData: state.userData,
        setUserData,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
